import { createContext, useContext, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Ctx = createContext(null);
export const usePageTransition = () => useContext(Ctx);

export function TransitionProvider({ children }) {
  const navigate = useNavigate();
  const [phase, setPhase] = useState("idle"); // idle | cover | reveal
  const pending = useRef(null);

  const go = useCallback(
    (to) => {
      if (phase !== "idle") return;
      if (typeof window !== "undefined" && window.location.pathname === to) return;
      pending.current = to;
      setPhase("cover");
    },
    [phase]
  );

  const onCoverDone = () => {
    if (pending.current) {
      navigate(pending.current);
      pending.current = null;
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
    setPhase("reveal");
  };

  return (
    <Ctx.Provider value={{ go }}>
      {children}
      <AnimatePresence>
        {phase !== "idle" && (
          <motion.div
            key="curtain"
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 z-[9999]"
            style={{
              transformOrigin: phase === "cover" ? "left center" : "right center",
              background:
                "linear-gradient(100deg,#050505 0%,#1a0000 45%,#3a0000 66%,#d91616 86%,#ff3030 100%)",
            }}
            initial={{ scaleX: 0 }}
            animate={{ scaleX: phase === "cover" ? 1 : 0 }}
            transition={{ duration: 0.55, ease: [0.76, 0, 0.24, 1] }}
            onAnimationComplete={() => {
              if (phase === "cover") onCoverDone();
              else setPhase("idle");
            }}
          >
            <div className="relative h-full w-full overflow-hidden">
              <span className="font-jp absolute inset-0 grid place-items-center text-[42vw] leading-none text-black/25">
                峠
              </span>
              <motion.span
                initial={{ x: "-120%" }}
                animate={{ x: phase === "cover" ? "120%" : "260%" }}
                transition={{ duration: 0.6, ease: [0.5, 0, 0.2, 1] }}
                style={{ rotate: -18 }}
                className="absolute top-1/2 left-0 h-[3px] w-[160vw] bg-gradient-to-r from-transparent via-white to-[#ff2d2d]"
              >
                <span className="absolute -top-2 left-1/2 h-5 w-5 -translate-x-1/2 rounded-full bg-white shadow-[0_0_30px_14px_rgba(255,60,60,0.9)]" />
              </motion.span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </Ctx.Provider>
  );
}
